import { ReactNode, useId } from 'react';
import { Grid, Text } from '@simplywallst/ui-core';
import Tooltip from '@/components/Tooltip';
import { Term, TooltipTitle } from './styled';

type TooltipProps =
  | {
      tooltip: ReactNode;
      labelTerm: ReactNode;
    }
  | {
      tooltip?: never;
      labelTerm?: never;
    };

type Props = {
  children: ReactNode;
  label: ReactNode;
} & TooltipProps;

export const LabelledValue = ({
  label,
  labelTerm,
  children,
  tooltip,
}: Props) => {
  const id = useId();
  return (
    <Grid templateColumns="auto auto" justifyContent="space-between">
      <Text typography="xSmall" id={id}>
        {label}{' '}
        <Tooltip title={<TooltipTitle>{tooltip}</TooltipTitle>} light>
          <Term>{labelTerm}</Term>
        </Tooltip>
      </Text>
      {children && (
        <Text typography="xSmall" aria-labelledby={id}>
          {children}
        </Text>
      )}
    </Grid>
  );
};
